import { FC, ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import classNames from '../../../../../../utils/classnames';
import './toast-notification.scss';

export type ToastNotificationProps = {
    children: ReactNode;
    isOpen: boolean;
    onClose: () => void;
    closeAfter?: number;
    type?: 'success' | 'error' | null | string;
    className?: string;
};
const ToastNotification: FC<ToastNotificationProps> = (props) => {
    const { isOpen, children, closeAfter = 5000, type = 'success', onClose } = props;

    useEffect(() => {
        let timeoutId: ReturnType<typeof setTimeout> | null = null;

        if (isOpen) {
            timeoutId = setTimeout(() => onClose(), closeAfter);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [isOpen, closeAfter]);

    return createPortal(
        <div className={classNames('toast-container', props.className)}>
            <div onClick={onClose} className={`toast ${type} ${isOpen ? 'displayed' : 'hidden'}`}>
                {children}
            </div>
        </div>,
        document.getElementById('modal-root')!
    );
};

export default ToastNotification;
